export default function (props: any) {
    return (
        <svg width="76" height="76" viewBox="0 0 76 76" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h76v76H0z" />
                <g transform="translate(10 15)" stroke="#979797" strokeLinecap="round" strokeWidth="2">
                    <rect width="42" height="19" rx="4" />
                    <path d="M31 0v19M42 3h5a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3h-5 0V3zM51 9.05h6M5 19v26a1 1 0 0 0 1 1h3.028a3 3 0 0 0 2.738-1.773l5.74-12.806a3 3 0 0 1 2.737-1.773h1.579a3 3 0 0 0 2.798-1.917L28 19h0" />
                </g>
            </g>
        </svg>
    );
}
